<template>
  <div class="page-content">
    <section class="input-action">
      <div class="input">
        <input
          v-model="filter.text"
          :placeholder="'ค้นหาตำบล, อำเภอ, หรือ รหัสไปรณีย์'"
          type="text"
          class="el-input__inner"
          @keyup.enter="() => search(filter.text, 1)"
        />
      </div>
      <div class="action">
        <el-button
          icon="
            el-icon-search
          "
          @click="() => search(filter.text, 1)"
        >
          ค้นหา
        </el-button>
      </div>
    </section>

    <section v-if="loader" class="empty">
      <p>
        <b class="unknown"> กำลังค้นหา </b>
      </p>
    </section>

    <section v-if="!loader && items.length > 0" class="content">
      <div v-for="(item, i) in items" :key="i" class="item">
        <div class="item-content">
          <div class="icon">
            {{ item.zipCode }}
          </div>
          <div>
            <p>{{ item.tumbonPrefix }}{{ item.tumbonName }}</p>
            <label> {{ item.amphurPrefix }}{{ item.amphurName }} </label>
          </div>
        </div>
        <el-button
          plain
          type="sc-asset"
          class="item-action"
          @click="() => (value = item)"
        >
          เลือก
        </el-button>
      </div>
    </section>

    <section v-else-if="!loader" class="empty">
      <img src="@/assets/images/admin/empty.png" />
      <p>
        <b class="unknown"> ไม่พบข้อมูล </b>
      </p>
    </section>

    <section v-if="!loader && items.length > 0" class="footer">
      <el-pagination
        :background="true"
        :layout="'prev, pager, next'"
        :pager-count="5"
        :current-page="paging.page"
        :page-size="paging.limit"
        :total="paging.total"
        @current-change="(page) => search(filter.text, page)"
      />
      <label> พบ {{ paging.total }} รายการ </label>
    </section>
  </div>
</template>

<script lang="js">
// Services
import { NonScFeature } from "../feature"

export default {
  props: {
    selected: {
      type: String,
      default: undefined,
    },
    provinceCode: {
      type: String,
      default: undefined,
    },
  },
  data: () => ({
    value: null,
    items: [],
    filter: {
      text: "",
      province: null,
    },
    paging: {
      page: 1,
      limit: 10,
      total: 0,
    },
    loader: false,
  }),
  computed: {
    address() {
      return NonScFeature.address
    },
  },
  watch: {
    value(value) {
      this.$emit("selected", value)
    },
    loader(value) {
      this.$emit("loading", value)
    },
  },
  mounted() {
    this.search()
  },
  methods: {
    async search(text = "", page = 1) {
      // Loading
      this.loader = true

      try {
        // Filter Limitation
        const { limit } = this.paging

        // Filter Province
        const province = this.provinceCode

        // Fetch Params
        const params = {
          text,
          province,
          page,
          limit,
        }

        // Fetch Location List
        const { items, total } = await this.address.location(params)

        // Set Items
        this.items = items

        // Set Paging
        this.paging = {
          limit,
          page,
          total,
        }
      } catch (_) {
        // Reset Items
        this.items = []

        // Reset Paging
        Object.assign(this.paging, { page: 1, total: 0 })
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
  },
}
</script>

<style lang="css" scoped>
.page-content {
  gap: var(--size-md);
}

section {
  gap: var(--size-md);
  flex-direction: column;
}
section.content {
  overflow: auto;
}
section.content {
  display: grid;
  gap: var(--size-sm);
  grid-template-columns: repeat(2, 1fr);
  overflow: auto;
}
section.footer {
  gap: 0.25rem;
  align-items: center;
}

.item {
  align-items: center;
  justify-content: space-between;
  padding: var(--size-sm);
}
.item .icon {
  font-weight: bold;
  padding: var(--size-xs);
  background: var(--color-light);
  color: var(--color-primary);
}

.item-content {
  display: flex;
  gap: var(--size-sm);
  align-items: center;
}
.item-content label {
  margin: 0;
}

@media screen and (max-width: 768px) {
  section .content {
    grid-template-columns: 1fr;
  }

  .item {
    flex-direction: column;
    align-items: flex-end;
  }
  .item .icon {
    font-size: 0.8rem;
  }
  .item-content {
    width: 100%;
  }
}
</style>
